export const AttentionTypeEnum = {
  HEALTHINSURANCE: "Obra Social",
  STAFF: "Staff Mediline",
  PARTICULAR: "Particular",
};